import { render, staticRenderFns } from "./CustomerKey.vue?vue&type=template&id=4124bc7c"
import script from "./CustomerKey.vue?vue&type=script&lang=js"
export * from "./CustomerKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports